import { t } from "i18next";
import { useState } from "react";

interface UsePostStripeReturn<P> {
  data: P;
  error: string | null;
  isLoading: boolean;
  triggerFetch: (fetchFunction: () => Promise<P>) => void;
}

interface UsePostStripeState<T> {
  data: T | null;
  error: string | null;
  isLoading: boolean;
}

export function usePostStripe<T>(): UsePostStripeReturn<T | null> {
  const [state, setState] = useState<UsePostStripeState<T>>({
    data: null,
    error: null,
    isLoading: false,
  });

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  async function triggerFetch(fetchFunction: () => Promise<T | null>) {
    setState({ ...state, isLoading: true });

    try {
      const result = await fetchFunction();
      setState({
        data: result,
        error: null,
        isLoading: false,
      });
    } catch (error) {
      setState({
        data: null,
        error: error instanceof Error ? error.message : t("common.error"),
        isLoading: false,
      });
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-misused-promises
  return { ...state, triggerFetch };
}
